import { render, staticRenderFns } from "./EmployeeFolderDelete.vue?vue&type=template&id=72b398a6&scoped=true&"
import script from "./EmployeeFolderDelete.vue?vue&type=script&lang=js&"
export * from "./EmployeeFolderDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b398a6",
  null
  
)

export default component.exports